import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirAllergyIntolerance } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirAllergyIntolerance.STARTED]: handleActionStart,
  [fetchFhirAllergyIntolerance.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirAllergyIntolerance.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.allergyIntolerance,
  [clearCurrentPatient]: () => initialState,
});
